import request from '@/utils/request';

// 生成确认单信息
export function cartConfirmOrder(data) {
  return request({
    url: '/order/front/order/cartConfirmOrder/v2',
    method: 'post',
    data
  });
}

// 生成订单
export function generateOrder(data) {
  return request({
    url: '/order/front/order/generateOrder/v2',
    method: 'post',
    data
  });
}

// 去支付  http://47.96.159.20:9080/dev-api/order/pay/wxPay?orderId=1
export function toPay(data) {
//   console.log('process.env.VUE_APP_BASE_API', process.env.VUE_APP_BASE_API);
  location.href = process.env.VUE_APP_BASE_API + `/order/pay/wxPay?orderId=${data}`;
  // location.href.replace(process.env.VUE_APP_BASE_API + `/order/pay/wxPay?orderId=${data}`);
//   let data = {
//     orderId: param
//   };
//   return request({
//     url: `/order/pay/wxPay`,
//     method: 'post',
//     data
//   });
}
// 去微信支付获取code
export function toWechatPay(data, campusCode, isReceipt) {
  let path = isReceipt ? `/order/front/wxPay/obtain/receipt/code?isReceipt=1` : '/order/front/wxPay/obtain/code?isReceipt=0';
  if (campusCode) {
    location.href = process.env.VUE_APP_BASE_API + `${path}&orderId=${data}&campusCode=${campusCode}`;
  } else {
    location.href = process.env.VUE_APP_BASE_API + `${path}&orderId=${data}&campusCode=`;
  }

  // return request({
  //   url: `/order/front/wxPay/obtain/code?orderId=${data}`,
  //   method: 'get'
  // });
}

// 去微信支付获取code
export function getWechatPayInfo(data) {
  let path = data.isReceipt ? '/order/front/wxPay/jsapi/receipt' : '/order/front/wxPay/jsapi';
  return request({
    url: `${path}/${data.orderId}/${data.code}`,
    method: 'post'
  });
}

// 获取订单列表
export function getOrderList(data) {
  return request({
    url: `/order/front/order/list`,
    method: 'post',
    data
  });
}

// 用户取消订单
export function cancelUserOrder(data) {
  return request({
    url: `/order/front/order/cancelUserOrder`,
    method: 'post',
    data
  });
}

// 根据ID获取订单详情
export function getOrderDetail(data) {
  return request({
    url: `/order/front/order/detail`,
    method: 'post',
    data
  });
}
// 获取退款列表
export function getDrawbackList(params) {
  return request({
    url: `/order/front/refund/list/orderNo/${params.orderNo}?isReceipt=${params.isReceipt}`,
    method: 'get'
  });
}

// 获取支付方式
export function getPayTypeList(params) {
  return request({
    url: `/system/front/payAccount/payType/${params}`,
    method: 'get'
  });
}

// 申请退款
export function requestDrawback(data) {
  return request({
    url: `/order/front/refund`,
    method: 'post',
    data
  });
}

// 检查是否可以退款
export function checkCanDrawback(data) {
  return request({
    url: `/order/front/refund/check`,
    method: 'post',
    data
  });
}

// 查看退款金额
export function refundAmount(data) {
  return request({
    url: `/order/front/refund/amount`,
    method: 'post',
    data
  });
}

// 获取退款详情
export function getRefundDetails(params) {
  return request({
    url: `/order/front/refund/${params}`,
    method: 'get'
  });
}
// 检查是否允许换课
export function checkAllowExchange(orderItemId) {
  return request({
    url: `/order/front/course/allowExchange/${orderItemId}`,
    method: 'get'
  });
}

// 换课详情
export function getExchangeDetails(id) {
  return request({
    url: `/order/front/course/detail/${id}`,
    method: 'get'
  });
}
// 取消退款
export function cancelDrawback(params) {
  return request({
    url: `/order/front/refund/cancel/${params}`,
    method: 'post'
  });
}

// 换课记录
export function getExchangeRecord(orderItemId) {
  return request({
    url: `/order/front/course/exchangeRecord/${orderItemId}`,
    method: 'get'
  });
}

// 提交换课申请
export function submitExchangeOrder(data) {
  return request({
    url: `/order/front/course/exchange`,
    method: 'post',
    data
  });
}

// 取消换课申请
export function cancelExchangeOrder(orderItemId) {
  return request({
    url: `/order/front/course/unExchange/${orderItemId}`,
    method: 'post'
  });
}

// 选择支付宝付款
export function getAlipayData(data) {
  return request({
    url: '/payment/front/pay/unifiedOrder',
    method: 'post',
    data
  });
}

// 获取学生历史报名信息
export function getStudentApplyInfo(id) {
  return request({
    url: `/system/front/student/query/apply/info/${id}`,
    method: 'get'
  });
}

// 完善学生报名信息
export function patchStudentApplyInfo(data) {
  return request({
    url: '/system/front/student/patch/apply/info',
    method: 'post',
    data
  });
}

// 获取学生报名学校列表
export function getStudentSchoolTable() {
  return request({
    url: '/system/front/student/apply/school/table',
    method: 'get'
  });
}

// 判断是否中台支付
export function canPlatform(id) {
  return request({
    url: `/system/front/payAccount/checkIfUsePaymentHub/${id}`,
    method: 'post'
  });
}

// 获取支付中中台信息
export function getPlatformInfo(data) {
  return request({
    url: `/payment/front/pay/unifiedOrder`,
    method: 'post',
    data: data
  });
}

// 获取配置的冬令营链接
export function getTableLink(params) {
  return request({
    url: `/order/front/order/winterCampBiTableLink`,
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/order/index.js